import Request from '../utils/request';
import router from '@/router';
import { ElMessage } from 'element-plus';

let timer: ReturnType<typeof setTimeout>;
const request = new Request({
    baseURL: '',
    timeout: 10000,
    successCallback: (data) => {
        ElMessage.success(data.msg);
        // console.log('success', data);
    },
    errorCallback: (data) => {
        console.log('error', data);
        if (data.code === 14) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                ElMessage.closeAll();
                ElMessage.error(data.msg || '接口错误');
            }, 500);
        } else {
            ElMessage.closeAll();
            ElMessage.error(data.msg || '接口错误');
        }
    },
    loginExpired: () => {
        // console.log('loginExpired');
        router.push('/login');
    },
    wrongCallback: (msg: string) => {
        ElMessage.closeAll();
        ElMessage.error(msg);
    }
});

export default {
    get: request.get,
    post: request.post,
    put: request.put,
    delete: request.delete,
    request: request.request
};
